import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { IndustryService } from '../../services/industry.service';

/** Blocks /petty-cash for industries where petty cash is turned off (feature-flags.ts). */
export const pettyCashGuard: CanActivateFn = () => {
  return inject(IndustryService).isPettyCashEnabled()
    ? true
    : inject(Router).parseUrl('/dashboard');
};
